import React from 'react';
import IconInfo from '../../icon/IconInfo';
import UIInput from '../../../ui/form/UIInput';
import Tooltip from '../../../ui/Tooltip';

type Props = {
  className?: string
  label?: string
  value?: string
  name: string
  id: string
  tooltip?: React.ReactNode
};

export default function SideFormInput({
  id, label, className, tooltip,
}: Props) {
  return (
    <>
      <label htmlFor={id} className="block">
        {label}
        {tooltip &&
        <>
          <Tooltip content={tooltip}
            label={`${id}_label_tip`} className="pl-0.5">
            <IconInfo className="text-gray-dark "/>
          </Tooltip>
        </>
        }
      </label>
      <div className="mt-2">
        <UIInput name={id} id={id} className={className}/>
      </div>
    </>
  );
}
